import { Dayjs } from "dayjs"
import { IWarrantsAccountHistory } from "@/models/admin/warrantsAccountHistory/warrantsAccountHistory.types"
import { sentenceCase } from "@/helpers/stringHelpers"

export class WarrantsAccountHistory implements IWarrantsAccountHistory {
  constructor(
    public id: number,
    public accountNumber: string,
    public status: string,
    public currentStatus: string | null,
    public nextStatus: string | null,
    public message: string | null,
    public createdAt: Dayjs,
    public updatedAt: Dayjs,
    public deletedAt: Dayjs | null,
  ) {}

  get isDeleted(): boolean {
    return this.deletedAt !== null
  }

  get statusDisplay(): string {
    return sentenceCase(this.status)
  }

  get currentStatusDisplay(): string {
    return this.currentStatus ? sentenceCase(this.currentStatus) : "—"
  }

  get nextStatusDisplay(): string {
    return this.nextStatus ? sentenceCase(this.nextStatus) : "—"
  }
}
